import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';

import LogIn from '../LogIn/index';
import Authorize from '../Authorize/index';
import PostsPage from '../Posts/index';
import ProtectedRoute from '../ProtectedRoute';
import YourAccount from '../Overview';
import WalletPage from '../Wallet';
import CreatePage from '../Create';
import SettingsPage from '../Settings';
import WritePage from '../Write';
import BlogRoute from '../ProtectedRoute/BlogRoute';
import DomainsPage from '../Domains';

const Pages = () => (
  <Switch>
    <BlogRoute path="/drafts" component={PostsPage} />
    <BlogRoute path="/settings" component={SettingsPage} />
    <BlogRoute path="/write" component={WritePage} />
    <BlogRoute path="/edit/:draftId" component={WritePage} />
    <ProtectedRoute path="/wallet" component={WalletPage} />
    <ProtectedRoute path="/create" component={CreatePage} />
    <ProtectedRoute path="/domains" component={DomainsPage} />
    <ProtectedRoute path="/" component={YourAccount} />
  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/" component={Pages} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/login" component={LogIn} />
        <Route exact path="/authorize" component={Authorize} />
        <Route path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
